import { render, staticRenderFns } from "./RefsOutputAccordion.vue?vue&type=template&id=a5dab1dc&"
import script from "./RefsOutputAccordion.vue?vue&type=script&lang=js&"
export * from "./RefsOutputAccordion.vue?vue&type=script&lang=js&"
import style0 from "./RefsOutputAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports